import React from "react";
import PageHead from "../../Head";

import Context from "@/context/Context";
import ForgotPassword from "@/components/ForgotPassword/ForgotPassword";
import Header from "@/components/Header/Header";
import PopupMobileMenu from "@/components/Header/PopupMobileMenu";

const ForgotPasswordPage = () => {
  return (
    <>
      <PageHead title="Sign In" />

      <main className="page-wrapper">
        <Context>
          <Header
            headerTransparent="header-transparent"
            headerSticky="header-sticky"
            btnClass="btn-small round"
          />
          <PopupMobileMenu />

          <ForgotPassword />

        </Context>
      </main>
    </>
  );
};

export default ForgotPasswordPage;
